<template>
  <ol class="ContentProseOl">
    <slot />
  </ol>
</template>

<style lang="scss">
.ContentProseOl {
  padding-left: 0;
}
</style>
